import { Routes, Route } from "react-router-dom";
import Kyc from "./pages/Kyc/Kyc";
import Layout from "./components/Layout/Layout";
import AccValidation from "./pages/AccValidation/AccValidation";
import KycPreview from "./pages/KycPreview/KycPreview";
import Login from "./pages/Login/Login";
import { PrivateRoute } from "./components/PrivateRoute/PrivateRoute";
import { jwtDecode } from "jwt-decode";
import Config from "./service/Config";
import { CognitoIdentityProviderClient, InitiateAuthCommand } from "@aws-sdk/client-cognito-identity-provider";

function App() {
  
  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);

      if (decoded && decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return decoded.exp < currentTime;
      }
    } catch (error) {
      console.error("Error decoding token:", error);
      return true; // Treat decoding failures as expired tokens
    }
    return true;
  };

    const getNewTokens = async (authData) => {
    if (!authData.RefreshToken) {
      localStorage.removeItem("authToken");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      });

      const params = {
        ClientId: Config.Client_Id,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authData.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        const newAuthToken = {
          AccessToken: refreshResponse.AuthenticationResult.AccessToken,
          RefreshToken: authData.RefreshToken, // Keep old refresh token
          IdToken: refreshResponse.AuthenticationResult.IdToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuthToken));
       
      } else {
      }
    } catch (error) {
      console.error("Error refreshing tokens:", error);
      localStorage.removeItem("authToken");
    }
  };
  let token = localStorage.getItem("authToken");
  let parsedToken = token ? JSON.parse(token) : {};
  console.log("parsedToken", parsedToken);
  if (isTokenExpired(parsedToken.IdToken)) {
    console.log("expired");
    getNewTokens(parsedToken)
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />

      <Route element={<PrivateRoute />}>
        <Route path="/content" element={<Layout />}>
          <Route path="kyc" element={<Kyc />} />
          <Route path="kyc/:companyId/:entityType" element={<KycPreview />} />
          <Route path="acc-validation" element={<AccValidation />} />
        </Route>
      </Route>
    </Routes>
  );
}
export default App;
